export const WIDGET_TITLE_TYPE = 'title';
